import { TUser } from '../../api';

/** Данные текущего пользователя */
export const getCurrentUser = () => {
  const userData = localStorage.getItem('USER_DATA');
  return userData ? (JSON.parse(userData) as TUser) : null;
};

/** Проверяет, является ли текущий пользователь администратором */
export const hasResponsibleOrg = (medOrgId: string | undefined): boolean => {
  const currentUser = getCurrentUser();
  const medOrgIdFromUser = currentUser?.medorg && currentUser.medorg.id;

  return medOrgIdFromUser === medOrgId;
};
